import Actions from './Actions';
// BUI migration variant. Root/Trigger/TriggerButtonIcon and the context are
// reused from the originals (no MUI markup), the rest are migrated to BUI.
import ActionsBui from './ActionsBui';
import Body from './Body';
import BodyBui from './BodyBui';
import CloseButton from './CloseButton';
import CloseButtonBui from './CloseButtonBui';
import Content, { type ContentProps } from './Content';
import ContentBui, { type ContentBuiProps } from './ContentBui';
import { Form } from './Form';
import { FormBui } from './FormBui';
import Header from './Header';
import HeaderBui from './HeaderBui';
import ResourceGuard, { type ResourceGuardProps } from './ResourceGuard';
import ResourceGuardBui, {
  type ResourceGuardBuiProps,
} from './ResourceGuardBui';
import Root, {
  type BaseDialogProps,
  type ControlledDialogProps,
  type RootHandlers,
  type RootProps,
  type StaticDialogProps,
} from './Root';
import SubmitError from './SubmitError';
import SubmitErrorBui from './SubmitErrorBui';
import Subtitle from './Subtitle';
import SubtitleBui from './SubtitleBui';
import Title from './Title';
import TitleBui from './TitleBui';
import Trigger from './Trigger';
import TriggerButtonIcon, {
  type TriggerButtonIconProps,
} from './TriggerButtonIcon';

export type { RootHandlers as DialogRootHandlers };
export type { RootProps as DialogRootProps };
export type { ControlledDialogProps as DialogControlledProps };
export type { StaticDialogProps as DialogStaticProps };
export type { BaseDialogProps as DialogBaseProps };
export type { ContentProps as DialogContentProps };
export type { TriggerButtonIconProps };
export type { ResourceGuardProps as DialogResourceGuardProps };
export { useDialogContext } from './context';

export const DialogComposite = {
  Root,
  Content,
  Form,
  Header,
  Title,
  Subtitle,
  CloseButton,
  Body,
  Actions,
  ResourceGuard,
  Trigger,
  TriggerButtonIcon,
  SubmitError,
};

export type { ContentBuiProps as DialogContentPropsBui };
export type { ResourceGuardBuiProps as DialogResourceGuardPropsBui };

export const DialogCompositeBui = {
  Root,
  Content: ContentBui,
  Form: FormBui,
  Header: HeaderBui,
  Title: TitleBui,
  Subtitle: SubtitleBui,
  CloseButton: CloseButtonBui,
  Body: BodyBui,
  Actions: ActionsBui,
  ResourceGuard: ResourceGuardBui,
  Trigger,
  TriggerButtonIcon,
  SubmitError: SubmitErrorBui,
};
